import SideBlockAds from "@components/Blocks/Container/SideBlockAds";
import { getGTMData } from "@helper/getMetaData";
import type { BHBasePageProps } from "@routes/BHBasePage";
import BHBasePage from "@routes/BHBasePage";
import { ResponseType, TRouteWithRedirect } from "@sphtech/web2-core/ssr";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";
import type { GADataProps } from "@typings/GA";

export function meta() {
  return [
    {
      title: "Hubungi Kami, Berita - BeritaHarian.sg",
      slug: "/hubungi-kami",
      description: "Berita - . Baca lebih lanjut di BeritaHarian.sg",
    },
  ];
}

export function loader(): Promise<TRouteWithRedirect<object | null, string>> {
  const gaData: GADataProps = {
    level2: "miscellaneous",
    title: "Hubungi Kami",
    section: "miscellaneous",
    contentcat: "1",
    contenttype: "listing",
  };

  return Promise.resolve({
    type: ResponseType.SUCCESS,
    statusCode: 200,
    payload: null,
    cacheControlMaxAge: 300, // 5 minutes
    regenerateInterval: 172800, // 2 days
    gtm: getGTMData(gaData),
  });
}

export default function HubungiKami() {
  const uniqueSectionName = "hubungi-kami";
  const pageAdTargetType = PageAdTargetingTypeEnum.LISTING;
  const basePageProps: BHBasePageProps = {
    uniqueSectionName: uniqueSectionName,
    pageAdTargetValue: pageAdTargetType,
  };

  return (
    <BHBasePage {...basePageProps}>
      <div className="max-w-screen-bh-cxl m-auto flex flex-col lg:flex-row">
        <div className="flex lg:px-sm flex-col w-12/12 lg:w-8/12 w-full">
          <h1 className="flex text-lg font-bold mt-0 mb-12">Hubungi Kami</h1>
          <p className="font-primary text-xxs">
            Anda ada maklumat mengenai sesuatu berita menarik?
            <br />
            Hubungi hotline: 6319 8444
            <br />
            <a
              className="no-underline text-blue-300 hover:text-blue-800 hover:underline"
              href="mailto:bhnews@sph.com.sg"
            >
              E-mel: bhnews@sph.com.sg
            </a>
          </p>
          <p>&nbsp;</p>
          <div className="table border-collapse">
            <div className="table-header-group">
              <div className="table-cell font-bold text-[12.852px] w-[110.825px]">
                Jabatan
              </div>
              <div className="table-cell font-bold text-[12.852px] w-[110.825px]">
                Nombor telefon
              </div>
              <div className="table-cell font-bold text-[12.852px]">E-mel</div>
            </div>
            <div className="table-row-group text-[12.852px] font-regular">
              <div className="table-row">
                <div className="table-cell">Meja Berita</div>
                <div className="table-cell">6319 5601</div>
                <div className="table-cell">
                  <a
                    className="no-underline text-blue-300 hover:underline"
                    href="mailto:bhnews@sph.com.sg"
                  >
                    bhnews@sph.com.sg
                  </a>
                </div>
              </div>
            </div>
            <div className="table-row-group text-[12.852px] font-regular">
              <div className="table-row">
                <div className="table-cell">Meja Digital</div>
                <div className="table-cell">6319 5126</div>
                <div className="table-cell">
                  <a
                    className="no-underline text-blue-300 hover:underline"
                    href="mailto:bhonline@sph.com.sg"
                  >
                    bhonline@sph.com.sg
                  </a>
                </div>
              </div>
            </div>
            <div className="table-row-group text-[12.852px] font-regular">
              <div className="table-row">
                <div className="table-cell">Pertanyaan</div>
                <div className="table-cell">6319 8611</div>
                <div className="table-cell">
                  <a
                    className="no-underline text-blue-300 hover:underline"
                    href="https://www.sph.com.sg/contact-us/?ctopic=advertising&amp;csubject=general%20advertising"
                  >
                    Klik di sini
                  </a>
                </div>
              </div>
            </div>
            <div className="table-row-group text-[12.852px] font-regular">
              <div className="table-row">
                <div className="table-cell">Khidmat Pelanggan</div>
                <div className="table-cell">6388 3838</div>
                <div className="table-cell">
                  <a
                    className="no-underline text-blue-300 hover:underline"
                    href="mailto:circs@sph.com.sg"
                  >
                    circs@sph.com.sg
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SideBlockAds
          adsSectionName={uniqueSectionName}
          adsOnly={true}
          pageAdTargetingProps={pageAdTargetType}
        />
      </div>
    </BHBasePage>
  );
}
